import React from 'react'
import { useState } from 'react'
import MyButton from '../../../../../UI/form/MyButton'
import MyModal from '../../../../../UI/modal/MyModal'
import SupplierContactForm from './SupplierContactForm'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

const SupplierContactButton = ({ supplierId, supplierContact }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            size='smExtra'
            onClick={e => setOpen(true)}
        >
            {
                // <AddIcon />
                supplierContact ? <EditIcon /> : <AddIcon />
            }
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={supplierContact ? 'Редагувати контакт' : 'Додати контакт'}
            // header={'Додати оплату'}
            disableClickOutside={true}
            content={
                <SupplierContactForm
                    supplierId={supplierId}
                    supplierContactBd={supplierContact}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default SupplierContactButton